// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"61044335","422":"8017f441","451":"d9361089","558":"b95e41da","579":"2aea8a1b","654":"308a6b64","671":"ff9b275a","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};